import styles from './styles.module.css';

const Nameplate = (props) => {

    const {
        sections,
        title,
        subtitle,
        summary,
        sectionUrl,
        isLiveBlogs
    } = props;
  
    const firstSection = sections?.[0];

    return (
        <div className={`${styles["section-container-title"]}`}>
            <ul className={`${styles["article-section-title"]}`} itemScope itemType="https://schema.org/BreadcrumbList">
            {firstSection && (
                <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
                <a itemProp="item" href={`${process.env.NEXT_PUBLIC_DOMAIN_URL}${sectionUrl}`}>
                <span itemProp="name">{firstSection.name.toUpperCase()}</span>
                </a>
            <meta itemProp="position" content="1" />
            </li>
            )}
            </ul>
            <div className={"orig-container"}>
                <div className={`${styles["volanta-text"]}`}>
                {isLiveBlogs && <span className={`${styles["news_liveblog_badge"]}`}>En Vivo</span>} {subtitle}
                </div>
                <h1 className={`headline-text`}>{title} </h1>
                {summary && (
                    <h2
                        className={`${styles["note-hook"]}`}
                        dangerouslySetInnerHTML={{
                            __html: summary,
                        }}
                    />
                )}
            </div>
        </div>
    )
}

export default Nameplate;